import * as React from "react";
import { Link } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import {
	Container,
	Input,
	Button,
	Form,
	Grid,
	Segment,
	Header,
	Message
} from "semantic-ui-react";
import { auth } from "../../firebase";

interface IProps extends RouteComponentProps<{}> {}

interface IState {
	email: string;
	password: string;
	error: string;
	isLoading: boolean;
}

class LoginPage extends React.Component<IProps, IState> {
	state = {
		email: "",
		password: "",
		error: "",
		isLoading: false
	};

	handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
		//any cast, to bypass typechecker
		this.setState({
			[evt.currentTarget.name]: evt.currentTarget.value
		} as any);
	};

	handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const { email, password } = this.state;

		this.setState({ error: "", isLoading: true });

		auth
			.signInWithEmailAndPassword(email, password)
			.then(authUser => {

				// this.props.history.push("/" )

			})
			.catch(error => {
				this.setState({
					error: error.message,
					isLoading: false
				});
			});
	};

	render() {
		const { email, password, error } = this.state;
		const isInvalid = email == "" || password == "";
		return (
			<Grid
				textAlign="center"
				style={{ height: "100%" }}
				verticalAlign="middle"
			>
				<Grid.Column style={{ maxWidth: 450 }}>
					<Form size="large" onSubmit={this.handleSubmit}>
						<Segment stacked>
							<Header as="h2" textAlign="center">
								Log-in to your account
							</Header>
							{this.state.error && (
								<Message negative style={{ textAlign: "left" }}>
									Please check your username and password, and
									try again
									{/* <Message.Header> */}
									{/* </Message.Header> */}
								</Message>
							)}
							<Form.Input
								fluid
								icon="mail"
								iconPosition="left"
								placeholder="E-mail address"
								value={this.state.email}
								onChange={this.handleChange}
								name="email"
								type="text"
							/>
							<Form.Input
								fluid
								placeholder="Password"
								icon="lock"
								iconPosition="left"
								value={this.state.password}
								onChange={this.handleChange}
								name="password"
								type="password"
							/>
							<Link to="/forgot"> Forgot Password? </Link>
							<br />
							<br />
							<Button
								fluid
								size="large"
								type="submit"
								disabled={isInvalid}
								loading={this.state.isLoading}
							>
								Submit
							</Button>
						</Segment>
					</Form>
				</Grid.Column>
			</Grid>
		);
	}
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/LoginPage/LoginPage.tsx